import Cookies from 'js-cookie';
import { decryptData } from 'utils/crypto';


export const dashboardSteps = () => {
  const roleId = Number(decryptData(Cookies.get("role_id")));
  const isAdmin = roleId === 1 || roleId === 2;
  return [
    {
      target: '[data-tour="clock-button"]',
      title: '⏰ Clock In / Out',
      content: 'Track your work hours by clocking in and out here.',
      disableBeacon: true,
    },
    {
      target: '[data-tour="profile-avatar"]',
      title: '👤 Profile Menu',
      content: isAdmin
        ? 'Access administrative actions such as Create Role, User Management, Offboarding, Update Password, and Logout.'
        : 'View your profile, update your password, and logout securely.',
      disableBeacon: true,
    },
    {
      target: '[data-tour="notification-bell"]',
      title: '🔔 Notifications',
      content: 'View your latest notifications here.',
      disableBeacon: true,
    },
    {
      target: '[data-tour="dashboard-main-card"]',
      title: '🏠 Dashboard',
      content: 'This is your main dashboard overview.',
      disableBeacon: true,
    },
    {
      target: '[data-tour="dashboard-inbox-card"]',
      title: '📬 Inbox',
      content: 'Check your inbox messages here.',
      disableBeacon: true,
    },
    {
      target: '[data-tour="holidays-card"]',
      title: '🎉 Holidays',
      content: 'View upcoming holidays here.',
      disableBeacon: true,
    },
    {
      target: '[data-tour="dashboard-leave-card"]',
      title: '🏖️ Leave',
      content: 'See who is on leave today.',
      disableBeacon: true,
    },
    {
      target: '[data-tour="remote-card"]',
      title: '🏠 Remote Work',
      content: 'See who is working remotely today.',
      disableBeacon: true,
    },
    {
      target: '[data-tour="dashboard-extra-card"]',
      title: '📊 Analytics',
      content: '🎈 Celebrate special moments! 🎂 Discover birthdays, 🎊 work anniversaries, and 👋 greet new team members here.',
      disableBeacon: true,
    },
  ];
};
